export default {
    title: {
        de: 'german',
        en: 'english'
    },
    form: {
        title: {
            label: 'Title',
            error: 'Please enter a title!'
        },
        description: {
            label: 'Description',
            error: 'Please enter a description!'
        }
    }
}
